import styled from "ibis-design-system/lib/HelperFunctions/ThirdParty/styled-components";
import {IFoundation} from "../Interfaces/IFoundation";

export const CollectionHeader = styled.div`
  font-weight: ${(props: IFoundation) => props.theme.fontWeights.light};
  margin-bottom: 22px;
  margin-top: 24px;
  margin-left: 31px;
  font-size: ${(props: IFoundation) => props.theme.fontSizes.xxl};
`